"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var storefront_api_client_1 = require("@shopify/storefront-api-client");
var graphql_tag_1 = require("graphql-tag");
var printer_1 = require("graphql/language/printer");
var queries_js_1 = require("./queries.js");
/**
 * Wrapper class for the Shopify Storefront API (GraphQL).
 * Designed to be a replacement for the deprecated shopify-buy-sdk,
 * with the same method structure and return values.
 * It supports localization if you provide the country and language codes, defaulting to CA and EN.
 *
 * Migration instructions:
 * 1. Install `@shopify/storefront-api-client`
 * ```sh
 * yarn add "@shopify/storefront-api-client" -S
 * yarn remove "shopify-buy"
 * ```
 * 2. Instantiate in the frontend:
 * ```ts
 * client = new ShopifyWrapper(domain, storefrontAccessToken, 'CA', getPageLang().toUpperCase());
 * ```
 * 3. Update any calls to `client.checkout.*` to `client.cart.*`
 * 4. Test all functionalities to confirm they work as expected.
 */
var ShopifyWrapper = /** @class */ (function () {
    /**
     * Create a new instance of the ShopifyWrapper class.
     * @param domain Shopify store domain (e.g., 'example.myshopify.com')
     * @param token Shopify storefront access token
     * @param apiVersion Shopify API version (default is '2025-01')
     * @param country Country code (default is 'CA')
     * @param language Language code (default is 'EN')
     * @param metafields Metafields to pull (optional)
     */
    function ShopifyWrapper(_a) {
        var domain = _a.domain, token = _a.token, _b = _a.apiVersion, apiVersion = _b === void 0 ? '2025-01' : _b, _c = _a.country, country = _c === void 0 ? 'CA' : _c, _d = _a.language, language = _d === void 0 ? 'EN' : _d, metafields = _a.metafields, _e = _a.debug, debug = _e === void 0 ? false : _e;
        var _this = this;
        /**
         * Cart wrapper object so it matches the shopify-buy API's structure.
         * TODO: Make sure it's typed. This works but I don't really like it being an extra function call...
         * The this.createCart.bind(this) is nicer, but it's not typed.
         */
        this.cart = {
            create: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.createCart()];
            }); }); },
            fetch: function (cartId) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchCart(cartId)];
            }); }); },
            updateAttributes: function (cartId, attributes) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.updateCartAttributes(cartId, attributes)];
            }); }); },
            // updateNote: async (cartId: string, note: string) => this.updateCartNote(cartId, note),
            addLineItems: function (cartId, lineItems) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.addLineItems(cartId, lineItems)];
            }); }); },
            removeLineItems: function (cartId, lineItemIds) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.removeLineItems(cartId, lineItemIds)];
            }); }); },
            updateLineItems: function (cartId, lineItems) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.updateLineItems(cartId, lineItems)];
            }); }); },
        };
        /**
         * Product wrapper object so it matches the shopify-buy API's structure.
         * TODO: Make sure it's typed. This works but I don't really like it being an extra function call...
         * The this.createCart.bind(this) is nicer, but it's not typed.
         */
        this.product = {
            fetch: this.fetchProduct.bind(this),
            fetchByHandle: this.fetchProductByHandle.bind(this),
        };
        // TODO: Add fetchAllWithProducts (just used in Reids)
        // public collection = {
        //   // Matches shopify-buy's client.collection.fetchAllWithProducts
        //   fetchAllWithProducts: async () => {
        //     // ...implementation to wrap client.collection.fetchAllWithProducts
        //   },
        // };
        /**
         * NOTE: This isn't the same as the `graphQLClient` from the Shopify Buy SDK.
         * The Shopify Buy SDK's `graphQLClient` is an instance of the deprecated
         * [graphql-js-client](https://www.npmjs.com/package/graphql-js-client) library.
         */
        this.graphQLClient = {
            /** Send a custom GraphQL query */
            send: function (query, variables) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.debugLog('== GraphQL query:', { query: query, variables: variables });
                    return [2 /*return*/, this.makeRequest(query, variables)];
                });
            }); },
        };
        /** Wrapper for test calls */
        this.test = {
            cart: this.testCart.bind(this),
            product: this.testProduct.bind(this),
            all: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.testCart()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.testProduct()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        console.debug('== Initializing ShopifyWrapper:', {
            domain: domain,
            token: token,
            apiVersion: apiVersion,
            country: country,
            language: language,
            metafields: metafields,
            debug: debug,
        });
        this.client = (0, storefront_api_client_1.createStorefrontApiClient)({
            storeDomain: domain,
            publicAccessToken: token,
            apiVersion: apiVersion,
        });
        this.country = country;
        this.language = language;
        this.metafields = {
            variant: (metafields === null || metafields === void 0 ? void 0 : metafields.variant)
                ? metafields.variant.map(function (field) { return _this.processMetafield(field); })
                : [],
            product: (metafields === null || metafields === void 0 ? void 0 : metafields.product)
                ? metafields.product.map(function (field) { return _this.processMetafield(field); })
                : [],
        };
        this.debug = debug;
    }
    /**
     * Processes a metafield input and returns a metafield specification (fill in the defaults).
     * @param metafield The metafield input to process.
     * @returns The processed metafield specification.
     */
    ShopifyWrapper.prototype.processMetafield = function (metafield) {
        return {
            name: metafield.name || metafield.key,
            namespace: metafield.namespace || 'custom',
            key: metafield.key,
        };
    };
    /** Log to console.debug if debug mode is enabled */
    ShopifyWrapper.prototype.debugLog = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.debug) {
            console.debug.apply(console, args);
        }
    };
    Object.defineProperty(ShopifyWrapper.prototype, "localeCode", {
        /**
         * Get the locale code of the current locale (i.e. en-CA or fr-CA).
         * Used in the checkout url.
         */
        get: function () {
            return "".concat(this.language.toLowerCase(), "-").concat(this.country.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    ShopifyWrapper.prototype.makeRequest = function (query, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var options, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            variables: variables,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.client.request(query, options)];
                    case 2:
                        response = _a.sent();
                        // { data, errors, extensions }
                        if (response.errors) {
                            console.error('GraphQL errors:', response.errors);
                            throw new Error('GraphQL errors occurred');
                        }
                        return [2 /*return*/, response.data];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error making request to Shopify API:', error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Resolve metafields for a given variant.
     * This will copy over any metafields that are shared between the variant and product
     * for single default variants, since Shopify makes one and doesn't copy the metafields.
     * @param variant The variant object to resolve metafields for.
     * @param product The product object (optional).
     * We were grabbing this from the variant, but it may not always be included inside the variant.
     * @returns An object containing the resolved metafield values.
     */
    ShopifyWrapper.prototype.resolveVariantMetafields = function (variant, product) {
        // const { product } = variant;
        var _this = this;
        var variantFieldsToAdd = this.metafields.variant.reduce(function (acc, field) {
            var _a, _b, _c;
            var variantFieldValue = (_a = variant[field.name]) === null || _a === void 0 ? void 0 : _a.value;
            // If we have the same metafield specified at the product-level, merge them
            var hasProductMetafield = _this.metafields.product.find(function (f) { return f.namespace === field.namespace && f.key === field.key; });
            if (hasProductMetafield && product) {
                // 1. Use variant metafield value if it exists
                // 2. If only a single variant exists (i.e. no variants), and it doesn't have a metafield value,
                //    use the product's metafield value, because the virtual variant Shopify creates
                //    doesn't auto-populate the variant's metafield
                var productFieldValue = (_b = product[field.name]) === null || _b === void 0 ? void 0 : _b.value;
                if (!variantFieldValue && productFieldValue && ((_c = product.variants) === null || _c === void 0 ? void 0 : _c.length) === 1) {
                    variantFieldValue = productFieldValue;
                }
            }
            acc[field.name] = variantFieldValue;
            return acc;
        }, {});
        return variantFieldsToAdd;
    };
    /**
     * Resolve metafields for a given product.
     * @param product The product object to resolve metafields for.
     * @returns An object containing the resolved metafield values.
     */
    ShopifyWrapper.prototype.resolveProductMetafields = function (product) {
        var productFieldsToAdd = this.metafields.product.reduce(function (acc, field) {
            var _a;
            var productFieldValue = (_a = product[field.name]) === null || _a === void 0 ? void 0 : _a.value;
            acc[field.name] = productFieldValue;
            return acc;
        }, {});
        return productFieldsToAdd;
    };
    /**
     * Format new GraphQL API `lines` to the shopify-buy `lineItems` structure.
     * @param lines The `lines` array from the new Shopify GraphQL API.
     * @returns An array of formatted line items.
     */
    ShopifyWrapper.prototype.formatLineItems = function (lines) {
        var _this = this;
        this.debugLog('== Formatting line items:', lines);
        var formattedLineItems = lines.edges.map(function (edge) {
            var line = edge.node;
            var variant = line.merchandise;
            var product = variant.product;
            var variantFieldsToAdd = _this.resolveVariantMetafields(variant, product);
            var productFieldsToAdd = _this.resolveProductMetafields(product);
            return __assign({ id: line.id, title: line.merchandise.product.title, variant: __assign({ id: line.merchandise.id, title: line.merchandise.title, sku: line.merchandise.sku, 
                    // These are priceV2 objects in both old and new APIs
                    price: line.merchandise.price, compareAtPrice: line.merchandise.compareAtPrice, selectedOptions: line.merchandise.selectedOptions, image: __assign(__assign({}, line.merchandise.image), { src: line.merchandise.image.url }), product: line.merchandise.product }, variantFieldsToAdd), quantity: line.quantity, customAttributes: line.attributes }, productFieldsToAdd);
        });
        this.debugLog('== Formatted line items:', formattedLineItems);
        return formattedLineItems;
    };
    /** Format the cart object to match the shopify-buy API structure */
    ShopifyWrapper.prototype.formatCart = function (cart) {
        this.debugLog('== Formatting cart:', cart);
        var formattedCart = __assign(__assign({}, cart), { 
            // Update/add any new fields
            // TODO: I think the checkout is supposed to open in the cart's locale, but it always seems to do English.
            // This page shows you can pass a locale param in the URL to do it, so I'm just adding it myself for now...
            // https://community.shopify.com/c/hydrogen-headless-and-storefront/storefront-api-and-multiple-languages/m-p/948026/highlight/true#M5587
            webUrl: "".concat(cart.checkoutUrl, "&locale=").concat(this.localeCode), currencyCode: cart.cost.totalAmount.currencyCode, lineItems: this.formatLineItems(cart.lines), subtotalPrice: cart.cost.subtotalAmount, totalPrice: cart.cost.totalAmount, totalTax: cart.cost.totalTaxAmount });
        // TODO: Should we remove the old fields?
        ['checkoutUrl', 'lines', 'cost'].forEach(function (field) {
            if (formattedCart[field]) {
                delete formattedCart[field];
            }
        });
        this.debugLog('== Formatted cart:', formattedCart);
        return formattedCart;
    };
    /**
     * Format new GraphQL API `variants` to the shopify-buy API's structure.
     * @returns An array of formatted variants.
     */
    ShopifyWrapper.prototype.formatVariants = function (variants, product) {
        var _this = this;
        this.debugLog('== Formatting variants:', variants);
        var formattedVariants = variants.edges.map(function (edge) {
            var variant = edge.node;
            var variantFieldsToAdd = _this.resolveVariantMetafields(variant, product);
            return __assign({ id: variant.id, title: variant.title, sku: variant.sku, 
                // These are priceV2 objects in both old and new APIs
                price: variant.priceV2, compareAtPrice: variant.compareAtPriceV2, selectedOptions: variant.selectedOptions, image: __assign(__assign({}, variant.image), { src: variant.image.url }) }, variantFieldsToAdd);
        });
        this.debugLog('== Formatted variants:', formattedVariants);
        return formattedVariants;
    };
    /** Format the product object to match the shopify-buy API structure */
    ShopifyWrapper.prototype.formatProduct = function (product) {
        this.debugLog('== Formatting product:', product);
        var productFieldsToAdd = this.resolveProductMetafields(product);
        var formattedProduct = __assign(__assign(__assign({}, product), { variants: this.formatVariants(product.variants, product) }), productFieldsToAdd);
        this.debugLog('== Formatted product:', formattedProduct);
        return formattedProduct;
    };
    /**
     * Creates a new cart in Shopify.
     * Implementation to wrap shopify-buy's client.checkout.create.
     * @returns The created cart or null if the creation failed.
     */
    ShopifyWrapper.prototype.createCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mutation, variables, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Creating new cart');
                        mutation = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation ($input: CartInput!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        cartCreate(input: $input) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation ($input: CartInput!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        cartCreate(input: $input) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            input: {},
                            country: this.country,
                            language: this.language,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.cartCreate.cart];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Error creating cart:', error_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Fetches the cart using the provided cart ID.
     * Implementation to match shopify-buy's client.checkout.fetch.
     *
     * "Checkout" is no longer supported in the Storefront API.
     * The Storefront API now uses "Cart" instead of "Checkout".
     * If the user has a checkout ID and that's used, it will return null.
     * https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/checkout
     * https://shopify.dev/docs/api/storefront/latest/objects/Checkout
     * @param cartId The cart ID to fetch.
     * @returns The fetched cart or null if not found.
     */
    ShopifyWrapper.prototype.fetchCart = function (cartId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Fetching cart with ID:', cartId);
                        query = (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n      query($id: ID!) {\n        cart(id: $id) {\n          ...CartFields\n        }\n      }\n    "], ["\n      ", "\n      query($id: ID!) {\n        cart(id: $id) {\n          ...CartFields\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields));
                        variables = {
                            id: cartId,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(query), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cart)];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Error fetching cart:', err_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    ShopifyWrapper.prototype.updateCartAttributes = function (cartId, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var attributesArray, mutation, variables, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!attributes.note) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateCartNote(cartId, attributes.note)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.debugLog('== Updating cart attributes:', { cartId: cartId, attributes: attributes });
                        attributesArray = [];
                        if (Array.isArray(attributes)) {
                            attributesArray = attributes;
                        }
                        else if (attributes.customAttributes) {
                            attributesArray = attributes.customAttributes;
                        }
                        else {
                            attributesArray = Object.entries(attributes).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                return ({
                                    key: key,
                                    value: (value === null || value === void 0 ? void 0 : value.toString()) || '',
                                });
                            });
                        }
                        mutation = (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {\n        cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {\n        cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            cartId: cartId,
                            attributes: attributesArray,
                        };
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 4:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cartAttributesUpdate.cart)];
                    case 5:
                        error_3 = _a.sent();
                        console.error('Error updating cart attributes:', error_3);
                        return [2 /*return*/, null];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the note for a specific cart.
     * @param cartId The cart ID to update.
     * @param note The note to set for the cart.
     * @returns The updated cart or null if the update failed.
     */
    ShopifyWrapper.prototype.updateCartNote = function (cartId, note) {
        return __awaiter(this, void 0, void 0, function () {
            var mutation, variables, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Updating cart note:', { cartId: cartId, note: note });
                        mutation = (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation cartNoteUpdate($cartId: ID!, $note: String!) {\n        cartNoteUpdate(cartId: $cartId, note: $note) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation cartNoteUpdate($cartId: ID!, $note: String!) {\n        cartNoteUpdate(cartId: $cartId, note: $note) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            cartId: cartId,
                            note: note,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cartNoteUpdate.cart)];
                    case 3:
                        error_4 = _a.sent();
                        console.error('Error updating cart note:', error_4);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds line items to the cart.
     * Implementation to wrap shopify-buy's client.checkout.addLineItems.
     * @param cartId The cart ID to update.
     * @param lineItems The line items to add to the cart.
     * @returns The updated cart or null if the update failed.
     */
    ShopifyWrapper.prototype.addLineItems = function (cartId, lineItems) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanedLineItems, mutation, variables, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Adding line items to cart:', { cartId: cartId, lineItems: lineItems });
                        cleanedLineItems = lineItems.map(function (item) {
                            var _a;
                            var isOldLineItem = 'variantId' in item;
                            var cleaned = {
                                merchandiseId: isOldLineItem ? item.variantId : item.merchandiseId,
                                quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1,
                                attributes: isOldLineItem ? item.customAttributes : item.attributes,
                            };
                            // Make sure we always have an attributes array.
                            cleaned.attributes = cleaned.attributes || [];
                            return cleaned;
                        });
                        // TODO: The quantity doesn't seem to be working?
                        this.debugLog('== Cleaned line items:', cleanedLineItems);
                        mutation = (0, graphql_tag_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {\n        cartLinesAdd(cartId: $cartId, lines: $lines) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {\n        cartLinesAdd(cartId: $cartId, lines: $lines) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            cartId: cartId,
                            lines: cleanedLineItems,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cartLinesAdd.cart)];
                    case 3:
                        error_5 = _a.sent();
                        console.error('Error adding line items:', error_5);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes line items from the cart.
     * Implementation to wrap shopify-buy's client.checkout.removeLineItems.
     * @param cartId The cart ID to update.
     * @param lineItemIds The IDs of the line items to remove.
     * @returns The updated cart or null if the update failed.
     */
    ShopifyWrapper.prototype.removeLineItems = function (cartId, lineItemIds) {
        return __awaiter(this, void 0, void 0, function () {
            var lineItemIdsArray, mutation, variables, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Removing line items from cart:', { cartId: cartId, lineItemIds: lineItemIds });
                        lineItemIdsArray = Array.isArray(lineItemIds) ? lineItemIds : [lineItemIds];
                        mutation = (0, graphql_tag_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {\n        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {\n        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            cartId: cartId,
                            lineIds: lineItemIdsArray,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cartLinesRemove.cart)];
                    case 3:
                        error_6 = _a.sent();
                        console.error('Error removing line items:', error_6);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates line items in the cart.
     * Implementation to wrap shopify-buy's client.checkout.updateLineItems.
     * @param cartId The cart ID to update.
     * @param lineItems The line items to update in the cart.
     * @returns The updated cart or null if the update failed.
     */
    ShopifyWrapper.prototype.updateLineItems = function (cartId, lineItems) {
        return __awaiter(this, void 0, void 0, function () {
            var cleanedLineItems, mutation, variables, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Updating line items in cart:', { cartId: cartId, lineItems: lineItems });
                        cleanedLineItems = lineItems.map(function (item) {
                            var _a;
                            return ({
                                id: item.id,
                                quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1,
                                attributes: item.attributes || item.customAttributes || [],
                            });
                        });
                        // TODO: The quantity doesn't seem to be working?
                        this.debugLog('== Cleaned line items:', cleanedLineItems);
                        mutation = (0, graphql_tag_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", "\n      ", "\n      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {\n        cartLinesUpdate(cartId: $cartId, lines: $lines) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "], ["\n      ", "\n      ", "\n      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {\n        cartLinesUpdate(cartId: $cartId, lines: $lines) {\n          cart {\n            ...CartFields\n          }\n          userErrors {\n            ...UserErrorFields\n          }\n        }\n      }\n    "])), (0, queries_js_1.cartFieldsFragment)(this.metafields), queries_js_1.userErrorsFragment);
                        variables = {
                            cartId: cartId,
                            lines: cleanedLineItems,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(mutation), variables)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.formatCart(response.cartLinesUpdate.cart)];
                    case 3:
                        error_7 = _a.sent();
                        console.error('Error updating line items:', error_7);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches a product by its ID.
     * Implementation to wrap shopify-buy's client.product.fetch.
     * @param productId The product ID to fetch.
     * @returns The fetched product or null if the fetch failed/wasn't found.
     */
    ShopifyWrapper.prototype.fetchProduct = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Fetching product with ID:', productId);
                        query = (0, graphql_tag_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", "\n      query($id: ID!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        product(id: $id) {\n          ...ProductFields\n        }\n      }\n    "], ["\n      ", "\n      query($id: ID!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        product(id: $id) {\n          ...ProductFields\n        }\n      }\n    "])), (0, queries_js_1.productFieldsFragment)(this.metafields));
                        variables = {
                            id: productId,
                            country: this.country,
                            language: this.language,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(query), variables)];
                    case 2:
                        response = _a.sent();
                        if (!response.product) {
                            console.error('Product not found:', productId);
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.formatProduct(response.product)];
                    case 3:
                        err_2 = _a.sent();
                        console.error('Error fetching product:', err_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches a product by its handle.
     * Implementation to wrap shopify-buy's client.product.fetchByHandle.
     * @param handle The product handle to fetch.
     * @returns The fetched product or null if the fetch failed/wasn't found.
     */
    ShopifyWrapper.prototype.fetchProductByHandle = function (handle) {
        return __awaiter(this, void 0, void 0, function () {
            var query, variables, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.debugLog('== Fetching product with handle:', handle);
                        query = (0, graphql_tag_1.default)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      ", "\n      query($handle: String!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        product(handle: $handle) {\n          ...ProductFields\n        }\n      }\n    "], ["\n      ", "\n      query($handle: String!, $country: CountryCode, $language: LanguageCode)\n      @inContext(country: $country, language: $language) {\n        product(handle: $handle) {\n          ...ProductFields\n        }\n      }\n    "])), (0, queries_js_1.productFieldsFragment)(this.metafields));
                        variables = {
                            handle: handle,
                            country: this.country,
                            language: this.language,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.makeRequest((0, printer_1.print)(query), variables)];
                    case 2:
                        response = _a.sent();
                        if (!response.product) {
                            console.error('Product not found:', handle);
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.formatProduct(response.product)];
                    case 3:
                        err_3 = _a.sent();
                        console.error('Error fetching product:', err_3);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Test the cart calls */
    ShopifyWrapper.prototype.testCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cartId, cart, _a, updateAttributesCall, addLineItemsCall, lineItemId, updateLineItemsCall, removeLineItemsCall;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cartId = localStorage.getItem('lastCartId');
                        if (!cartId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cart.fetch(cartId)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        cart = _a;
                        this.debugLog('wrapper storedCart', cart);
                        if (!!cart) return [3 /*break*/, 5];
                        this.debugLog('no cart found');
                        return [4 /*yield*/, this.cart.create()];
                    case 4:
                        cart = _b.sent();
                        this.debugLog('new cart created', cart);
                        localStorage.setItem('lastCartId', cart.id);
                        cartId = cart.id;
                        return [3 /*break*/, 6];
                    case 5:
                        this.debugLog('cart found', cart);
                        _b.label = 6;
                    case 6: return [4 /*yield*/, this.cart.updateAttributes(cart.id, {
                            // customAttributes: [ { key: 'foo', value: 'bar' } ],
                            note: 'Gift wrapped',
                        })];
                    case 7:
                        updateAttributesCall = _b.sent();
                        this.debugLog('updateAttributesCall: ', updateAttributesCall);
                        return [4 /*yield*/, this.cart.addLineItems(cart.id, [
                                {
                                    variantId: 'gid://shopify/ProductVariant/50299132182821',
                                    quantity: 2,
                                    customAttributes: [
                                        { key: 'foo', value: 'bar' },
                                        { key: 'baz', value: 'qux' },
                                    ],
                                },
                            ])];
                    case 8:
                        addLineItemsCall = _b.sent();
                        this.debugLog('addLineItemsCall: ', addLineItemsCall);
                        lineItemId = addLineItemsCall.lineItems[0].id;
                        return [4 /*yield*/, this.cart.updateLineItems(cart.id, [
                                {
                                    id: lineItemId,
                                    quantity: 3,
                                    customAttributes: [
                                        { key: 'foo', value: 'updatedValue' },
                                    ],
                                },
                            ])];
                    case 9:
                        updateLineItemsCall = _b.sent();
                        this.debugLog('updateLineItemsCall: ', updateLineItemsCall);
                        return [4 /*yield*/, this.cart.removeLineItems(cart.id, [lineItemId])];
                    case 10:
                        removeLineItemsCall = _b.sent();
                        this.debugLog('removeLineItemsCall: ', removeLineItemsCall);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Test the product calls */
    ShopifyWrapper.prototype.testProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fetchProductCall, fetchProductByHandleCall;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.product.fetch('gid://shopify/Product/8329400385829')];
                    case 1:
                        fetchProductCall = _a.sent();
                        this.debugLog('fetchProductCall: ', fetchProductCall);
                        return [4 /*yield*/, this.product.fetchByHandle('raffi-co-box-chain')];
                    case 2:
                        fetchProductByHandleCall = _a.sent();
                        this.debugLog('fetchProductByHandleCall: ', fetchProductByHandleCall);
                        return [2 /*return*/];
                }
            });
        });
    };
    return ShopifyWrapper;
}());
exports.default = ShopifyWrapper;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
